import React from "react";

const About = () => (
  <section id="about" className="about">
    <h2>About Me</h2>
    <br />
    <p>Hi! I’m Aryan Sengar, a Computer Science undergraduate at The NorthCap University, Gurugram. I'm deeply passionate about Artificial Intelligence, System Design, Machine Learning, and VLSI. My work blends both software and hardware, reflecting my curiosity and love for solving real-world problems.</p>
    <br />
    <p>I describe myself as a curious, motivated learner who enjoys turning complex challenges into creative and efficient solutions. I value honesty, creativity, and collaboration, and I strive to bring these principles into every project I take on.</p>
    <br />
    <p>Throughout my academic journey, I’ve explored multiple areas of tech:</p>
    <ul>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Built AI-powered applications like Brain Tumor Classifiers using deep learning</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Designed digital circuits with Cadence Virtuoso</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Worked on backend systems and analytics dashboards</li>
    </ul>
    <br />
    <p>I’ve also earned certifications like:</p>
    <ul>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Microsoft Certified: Azure AI Fundamentals (AI-900)</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- AWS Academy Graduate – Cloud Foundations</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Cisco Networking Basics</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Cisco Python Essentials 2</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Cisco English for IT 1</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Cisco English for IT 2</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- MongoDB Basics</li>
    </ul>
    <br />
    <p>Beyond academics, I enjoy:</p>
    <ul>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Graphic design and digital poster creation</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Photography and video editing</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Playing strategy and logic-based games</li>
      <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Exploring emerging tech and reading tech blogs</li>
    </ul>
  </section>
);

export default About;